import { Card } from "./Card.js";

interface StatCardProps {
  label: string;
  value: string | number;
  sub?: string;
  trend?: "up" | "down" | "flat";
}

export function StatCard({ label, value, sub, trend }: StatCardProps) {
  const trendColor =
    trend === "up" ? "var(--bios-signal)" : trend === "down" ? "var(--bios-noise)" : "var(--bios-text-muted)";
  const trendGlyph = trend === "up" ? "▲" : trend === "down" ? "▼" : "";
  return (
    <Card title={label}>
      <p className="bios-stat-value">{value}</p>
      {sub && (
        <p className="bios-stat-sub" style={{ color: trendColor }}>
          {trendGlyph && <span style={{ marginRight: 4 }}>{trendGlyph}</span>}
          {sub}
        </p>
      )}
    </Card>
  );
}
